import { Component, ElementRef, Input } from '@angular/core';
import { Window } from '../../injectable';

import { DropdownState } from './dropdown.component';

@Component({
  selector: 'app-dropdown-button',
  templateUrl: './dropdown-button.component.html',
})
export class DropdownButtonComponent {
  @Input() state = <DropdownState>null;
  @Input() type: string;
  @Input() toggleFunction;

  constructor(private element: ElementRef, private window: Window) {
  }

  toggle() {
    if (this.toggleFunction) {
      this.toggleFunction();
      return;
    }

    if (!this.state.visible) {
      this.state.atTheBottom = this.element.nativeElement.getBoundingClientRect().bottom / this.window.height() > 1 / 2;
    }
    this.state.visible = !this.state.visible;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown/dropdown-button.component.ts